import React from 'react';
import { Route, Routes } from 'react-router-dom'; // Remove BrowserRouter import
import ServiceWebsite from './pages/ServiceWebsite';
import PaymentPage from './pages/PaymentPage';
import UploadPage from './pages/UploadPage';
import PrivacyPage from './pages/PrivacyPage';
import RequisitesPage from './pages/RequisitesPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<ServiceWebsite />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/requisites" element={<RequisitesPage />} />
    </Routes>
  );
}

export default App;